import {
    CartesianGrid,
    Legend,
    Line,
    LineChart,
    Tooltip,
    XAxis,
    YAxis,
} from 'recharts';

export interface ReportWidgetLineChartDataPoint {
    name: string;
    id: string;
    value1: number;
    value2: number;
}

interface ReportWidgetLineChartProps {
    data: ReportWidgetLineChartDataPoint[];
    showLegend: boolean;
    tooltipFormatter: (value: number) => string;
    lineNames: [string, string];
    width?: number;
    height?: number;
    disableAnimation?: boolean;
    xAxisTickFormatter?: (
        label: string | number,
        index: number,
        data: ReportWidgetLineChartDataPoint[],
    ) => string;
}

const DEFAULT_LINE_COLORS: [string, string] = [
    'rgb(34, 197, 94)',
    'rgb(148, 163, 184)',
];

export const ReportWidgetLineChart = ({
    data,
    showLegend,
    tooltipFormatter,
    lineNames,
    width,
    height,
    disableAnimation = false,
    xAxisTickFormatter,
}: ReportWidgetLineChartProps) => (
    <LineChart
        data={data}
        width={width}
        height={height}
        margin={{ top: 8, right: 16, left: 8, bottom: 8 }}
    >
        <CartesianGrid
            stroke="#E5E7EB"
            strokeDasharray="3 3"
            vertical={false}
        />
        <XAxis
            dataKey="name"
            tick={{ fontSize: 12, fill: '#000000' }}
            tickLine={false}
            tickFormatter={(value: string | number, index: number) =>
                xAxisTickFormatter
                    ? xAxisTickFormatter(value, index, data)
                    : String(value)
            }
        />
        <YAxis
            tick={{ fontSize: 12, fill: '#000000' }}
            tickLine={false}
            tickFormatter={(v: number) =>
                typeof v === 'number' ? tooltipFormatter(v) : String(v)
            }
        />
        <Tooltip
            formatter={(value: number) => tooltipFormatter(value)}
            labelFormatter={(label: string) => label}
        />
        {showLegend && (
            <Legend
                verticalAlign="top"
                align="left"
                iconType="circle"
                wrapperStyle={{
                    paddingBottom: '18px',
                    fontSize: '12px',
                    lineHeight: '16px',
                }}
            />
        )}
        <Line
            type="linear"
            dataKey="value1"
            name={lineNames[0]}
            stroke={DEFAULT_LINE_COLORS[0]}
            strokeWidth={2}
            dot={{ r: 2 }}
            activeDot={{ r: 4 }}
            isAnimationActive={!disableAnimation}
            legendType="circle"
        />
        <Line
            type="linear"
            dataKey="value2"
            name={lineNames[1]}
            stroke={DEFAULT_LINE_COLORS[1]}
            strokeWidth={2}
            dot={{ r: 2 }}
            activeDot={{ r: 4 }}
            isAnimationActive={!disableAnimation}
            legendType="circle"
        />
    </LineChart>
);
